
/**
* Events
*	Triggers
*		na-segmentEnded.vidbaby
*		na-player:state.vidbaby
*	Listening
*		na-playSegment.vidbaby
*		na-park.vidbaby
*		na-unPark.vidbaby
*		na-STTStarted.vidbaby
*		na-buildPlayer.vidbaby
*/

var player = {
	container: null,
	isPlaying: false,
	videoDom: null,
	inputCanvasDom: null,
	inputContext: null,
	outputCanvasDom: null,
	outputContext: null,
	idleVideos: null,
	currentSegment: null,
	initilized: false,
	lastDrawnFrameTime: null,
	state: {},
	init() {
		if(player.initilized) return;
		player.initilized = true;

		vidbaby.$(document).on('na-playSegment.vidbaby', (event, segment) => {
			player.play(segment);
		});

		vidbaby.$(document).on('na-microphoneStarted.vidbaby', (event, segment) => {
			player.idle();
		});

		vidbaby.$(document).on('na-buildPlayer.vidbaby', (event, containerDomId) => {
			player.build(containerDomId);
		});
    
		player.initState();

	    //this could be more efficient
	    player.idleVideos = vidbaby.config.idles.sort((a, b) => parseInt(b.weight) - parseInt(a.weight));
	    player.idleVideosWeightTotal = player.idleVideos.reduce((total, vid) => total + vid.weight, 0);
	},
	initState() {
		player.state = new Proxy({
			visible: true,
			muted: false,
			paused: true,
			segment: null
		}, {
			set(target, prop, value) {
				if(player.state[prop] === value) return Reflect.set(...arguments);
				var res = Reflect.set(...arguments);
                switch(prop) {
                    case 'visible':
                        break;
                    case 'muted':
                        player.videoDom.muted = Boolean(value);
                        break;
                    case 'paused':
                        player.videoDom.autoplay = !(value);
                        if(value) {
                            player.videoDom.pause();
                        } else {
                            requestAnimationFrame(player.draw.bind(event));
                            if(player.state.segment) {
                                try { //player maybe blocked if user hasnt interacted with page
                                    player.videoDom.play();
                                } catch(err) {
                                    console.log ("Error with vidbaby.player: " + err.message)
                                }
                            }
                        }
                        break;
                    case 'segment':
                        if(typeof value === 'string' && value.length > 2) {
                            player.videoDom.src = vidbaby.config.env.videoPath+'/'+player.state.segment+'.mp4';
                            try { //player maybe blocked if user hasnt interacted with page
                                player.videoDom.play();
                            } catch(err) {
                                console.log ("Error with vidbaby.player: " + err.message)
                            }
                        } else {
                            player.state.segment = player.randomIdle();
                        }
                        break;
                }
				vidbaby.$(document).trigger('na-player:state.vidbaby');
				return res;
                
            }

		});
	},
	build(containerDomId) {
		player.container = document.querySelector(containerDomId);
		
		player.inputCanvasDom = document.createElement('canvas');
	    player.outputCanvasDom = document.createElement('canvas');

		player.videoDom = document.createElement('video');
		player.container.appendChild(player.outputCanvasDom);
	    player.videoDom.setAttribute('webkit-playsinline', 'webkit-playsinline');
    	player.videoDom.setAttribute('playsinline', 'playsinline');
	    player.videoDom.onended = () => {
	    	//trigger na-segmentEnded from idle segments too
	    	vidbaby.$(document).trigger('na-segmentEnded.vidbaby', player.state.segment);
	    	player.idle();
	    }
	    player.videoDom.onerror = err => {
	    	player.state.segment = player.randomIdle();
	    }

	    //canvas conversions
	    player.inputContext = player.inputCanvasDom.getContext('2d');
	    player.outputContext = player.outputCanvasDom.getContext('2d');
	    vidbaby.$(document).trigger('na-playerBuilt.vidbaby');
	},
    draw() {
        if (player.state.paused === true) return;
        // schedule next call to this function
        requestAnimationFrame(player.draw.bind(event));

        if (player.lastDrawnFrameTime == player.videoDom.currentTime || player.videoDom.readyState < 2) return
        player.lastDrawnFrameTime = player.videoDom.currentTime;
        
        var halfHeight = player.videoDom.videoHeight/2;
        if (player.videoDom.videoWidth == 0) return
        
        player.inputCanvasDom.height = player.videoDom.videoHeight;
        player.outputCanvasDom.width = player.inputCanvasDom.width = player.videoDom.videoWidth;
        player.outputCanvasDom.height = halfHeight;
    
        // draw video data into the canvas
        player.inputContext.drawImage(player.videoDom, 0, 0, player.videoDom.videoWidth, player.videoDom.videoHeight, 0, 0, player.videoDom.videoWidth, player.videoDom.videoHeight);
        player.outputContext.drawImage(player.inputCanvasDom, 0, 0, player.videoDom.videoWidth, halfHeight, 0,0, player.videoDom.videoWidth, halfHeight);

        var inputData = player.inputContext.getImageData(0, halfHeight, player.videoDom.videoWidth, halfHeight).data;
        var outputImage = player.outputContext.getImageData(0, 0, player.videoDom.videoWidth, halfHeight);
        
        for (var i = 0; i < outputImage.data.length; i+=4) {
            outputImage.data[i+3] = inputData[i];
        }

        player.outputContext.putImageData(outputImage, 0, 0);
	},
	isIdle() {
		return (player.idleVideos.find(iv => iv.fileName === player.state.segment));
	},
	idle() {
		let idle = '';
    	while(!idle || idle == player.state.segment)
    		idle = player.randomIdle();
    	player.state.segment = idle;
	},
	getState() {
		return player.state;
	},
	mute() {
		player.state.muted = true;
	},
	unmute() {
		player.state.muted = false;
	},
	rewind() {
		console.log('rewind');
	},
	stop() {
		player.pause();
		player.state.segment = null;
		player.lastDrawnFrameTime = null;
	},
	pause() {
	    player.state.paused = true;
	},
	play(segment) {
		if(segment) {
			player.state.segment = segment;
		}
		player.state.paused = false;
	},
	randomIdle() {
		var rand = Math.floor(Math.random() * player.idleVideosWeightTotal);

		var i;
		for(i = 0;rand > 0;i++) {
			rand -= player.idleVideos[i].weight;
		}
		return player.idleVideos[i].fileName;
	}
};



export default player;
